export default {
  bodyRedirection: {
    id: 'vtest_payment_method_provider_redirection_html',
    defaultMessage:
      "We’ll send you to {provider, html}'s site to finish the payment. ",
  },
}
